import React  from 'react';
import { Col, Row, Container, Button, Card, Jumbotron as Jumbo, img, Table} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Nav from '../../../Component/Layouts/Nav';
import userImg from '../../../Assets/Img/userImg.png'
import { AuthContext } from '../../../Context/AuthContext';
import { roles } from '../../../Util/Constants/constant';


const Styles = styled.div `

.jumbotron-fluid{
    height: 130px;
}

tr td,th{
    padding: 15px;
}
`;

export const Profile = () => {
    const {user,user_type} = React.useContext(AuthContext)

return(
    <Styles>
        <Nav/>
        <Jumbo fluid>
        </Jumbo>
        
        <Container>
            <Card>
                     <Row className="p-5">
                        
                        <Col  md={4}>
                        <img  className="" src={userImg} alt="usersimage" height="200px" width="200px" />
                         </Col>
                         <Col md={8}>
                         <Table borderless hover responsive="sm" size="sm">
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <th>{user !== null ? user.first_name + ' ' + user.last_name:null  }</th>
                                </tr>
                                {user_type === roles.Admin ? 
                                <tr>
                                    <td>Role</td>
                                    <th className="text-danger">{user !== null ? user.role.name:null}</th>
                                </tr>
                                :null}
                                <tr>
                                    <td>Phone number</td>
                                    <th>{user !== null ? user.phonenumber:null  }</th>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <th>{user !== null ? user.email:null  }</th>
                                </tr>
                            </tbody>
                            </Table>
                         </Col>
                    </Row>   
                <center>
                    <Link to='/edit-profile'>
                <Button className="btn-create mb-5 mt-2 shadow-lg">Edit Profile</Button>
                </Link>
                </center>
            </Card>
            
        </Container>
        
    </Styles>
)}